<template>
    <div :class="['app-container', 'height-mobile-inherit']" v-if="isReady">
        <navbar class="show-for-large"></navbar>
        <mobile-navigation class="hide-for-large"></mobile-navigation>
        <cart-icon class="hide-for-large"></cart-icon>
        <user-login-modal></user-login-modal>
        <cart dusk="cart"></cart>
        <div class="height-mobile-inherit main-container">
            <div class="grid-x height-mobile-inherit">
                <div class="cell height-mobile-inherit page-content-container" ref="page-content-container">
                    <transition name="fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </div>
            </div>
        </div>
        <menu-modal></menu-modal>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import Navbar from '@/components/front/ui/Navbar.vue'
import MobileNavigation from '@/components/front/ui/MobileNavigation.vue'
import UserLoginModal from '@/components/front/user/UserLoginModal.vue'
import FoodModule from '@/stores/modules/food';
import UserModule from '@/stores/modules/user';
import { getModule } from 'vuex-module-decorators';
import { Watch } from 'vue-property-decorator';
import Cart from '@/components/front/cart/Cart.vue';
import CartIcon from '@/components/front/cart/CartIcon.vue';
import MenuModal from '@/components/front/ui/MenuModal.vue';
import CartModule from '@/stores/modules/cart';
import { triggerScrollEvent } from '@/utils/scroll-event-manager';
import AppModule from '@/stores/modules/app'
import LazyLoad from 'vanilla-lazyload/dist/lazyload.js';
import { triggerGlobalEvent } from '@/utils/global-event';
@Component({
    components: { Navbar, MobileNavigation, UserLoginModal, Cart, CartIcon, MenuModal }
})
export default class App extends Vue {

    foodModule!: FoodModule;
    userModule!: UserModule;
    cartModule!: CartModule;
    appModule!: AppModule;
    pageReady: boolean = false;

    created() {
        this.foodModule = getModule(FoodModule, this.$store);
        this.userModule = getModule(UserModule, this.$store);
        this.cartModule = getModule(CartModule, this.$store);
        this.appModule = getModule(AppModule, this.$store);
    }

    mounted() {
        this.$watch('isCartOpen', this.onCartOpen);
        this.$watch('isReady', this.onAppReady);
    }

    onCartOpen() {
        if (this.isCartOpen) {
            document.querySelector('body')!.classList.add('overflow-hidden');
        } else {
            document.querySelector('body')!.classList.remove('overflow-hidden');
        }
    }

    onAppReady() {
        if (this.isReady) {
            (<any>window).lazyLoadInstance = new LazyLoad({
                elements_selector: '.lazy',
                container: this.pageContentContainer
            });
            triggerGlobalEvent('lazy-load-loaded');
        }
    }

    @Watch('pageContentContainer')
    registerScrollEvents() {
        if (this.pageContentContainer) {
            this.pageContentContainer.addEventListener('scroll', () => triggerScrollEvent(this.pageContentContainer));
        }
    }

    get isReady() {
        if (this.foodModule.isReady && this.userModule.isReady) this.pageReady = true;
        return this.foodModule.isReady && this.userModule.isReady;
    }

    get pageContentContainer() {
        if (this.pageReady) {
            return <HTMLElement>this.$refs['page-content-container'];
        };
    }

    get isCartOpen() {
        return this.cartModule.isOpen;
    }

    get isAppOnline() {
        return this.appModule.isOnline;
    }

}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.app-container {
    &.overflow-hidden {
        overflow: hidden;
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
